import { z } from 'zod';

export const productsSchema = z.object({
  id: z.number(),
  name: z.string(),
  mainImage: z.string(),
  number: z.string().regex(/^p\d+-m\d+-c\d+-s\d+$/),
  productCategories: z.array(
    z.object({
      label: z.string(),
      value: z.string()
    })
  )
});
